import Vue from 'vue'
import Vuex from 'vuex'

import defaultState from './config'

import AuthStore from './modules/AuthStore'
import CategoriesStore from './modules/CategoriesStore'
import ColumnStore from './modules/ColumnStore'
import ConfigStore from './modules/ConfigStore'
import OrganizationStore from './modules/OrganizationStore'
import RoleStore from './modules/RoleStore'
import SitesStore from './modules/SitesStore'
import SiteStore from './modules/SiteStore'
import UserStore from './modules/UserStore'
import WechatStore from './modules/WechatStore'
import VideosStore from './modules/VideosStore'
import CeramicsStore from './modules/CeramicsStore'


Vue.use(Vuex)
let store = {
  state: defaultState,
  modules: {
    AuthStore,
    SiteStore,
    UserStore,
    OrganizationStore,
    RoleStore,
    ColumnStore,
    SitesStore,
    ConfigStore,
    WechatStore,
    CategoriesStore,
    VideosStore,
    CeramicsStore
  }
}
let state = new Vuex.Store(store)
export default state


// WEBPACK FOOTER //
// ./src/store/index.js